import { render } from "./ReviewCart.vue?vue&type=template&id=32800366"
import script from "./ReviewCart.vue?vue&type=script&lang=js"
export * from "./ReviewCart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__